import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { BsXLg } from "react-icons/bs";
import blankProfile from "../images/blank-profile.png";
const SchoolAdminDialog = ({
  opendialog,
  closeDialog,
  schoolDetails,
  switchSchool,
  schoolName,
}) => {
  return (
    <div>
      <Dialog
        id="dialogBox"
        className="dialog-styleone"
        open={opendialog}
        onClose={closeDialog}
      >
        <DialogTitle>
          <div className="row">
            <div className="col-10 col-md-10 col-lg-10">
              <span className="fs-20 semi-bold">School Name</span>
            </div>
            <div className="col-1 text-right ml-auto ">
              <BsXLg onClick={closeDialog} className="crossview cp"></BsXLg>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="clear10"></div>
          {schoolDetails &&
            schoolDetails.map((item, index) => (
              <div key={index} className="dashboard-box mb-3 cp">
                <div className="row">
                  <div className="col-3 col-md-3 col-lg-3 cp">
                    <img
                      src={
                        item.uploadedLogo
                          ? item.uploadedLogo.filePath
                          : blankProfile
                      }
                      alt="sclogo"
                      className="img img-responsive switchschlIMG"
                    ></img>
                  </div>
                  <div
                    className="col-9 col-md-9 col-lg-9 cp"
                    onClick={() =>
                      switchSchool(
                        item.id,
                        item.schoolName,
                        item.uploadedLogo.filePath
                      )
                    }
                  >
                    <div className="clear10"></div>
                    <label className="fs-20 regular black m-0 cp pl-3">
                      {item.schoolName}
                    </label>
                    {item.schoolName == schoolName && (
                      <div className="fs-16 bold pl-3 openschoolTEXTnew">
                        Open
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SchoolAdminDialog;
